import createModule from "../createModule"
import view from "./view"
import { getStyleAggregation, getFocusedChartLine, getDisplayAggregationToggle, getOnly, getFactorSensitivityType } from "./selectors"
import { getAvailableSelectViewFactors, getCategoryItemsSubset, getOptions, getSelectedOption, getFilteredData, getFirstFactorSensitivityDate, getSelectedFactorCategoryId, getSelectedFactorCategoryName, getAllCategoryItems, getFactorSensitivityData } from "./selectors/data"
import { getFileName } from "./selectors/file"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getThresholdParams } from "selectors/factorSensitivity"
import { getFactorSensitivityQueryParams } from "helpers/factorSensitivity"
import { getIsOpPro } from "modules/account-root/selectors"
import { convertPositionSetType } from "helpers/compositeSecurities"

export default createModule({
  view,
  externalProps: (state, props) => ({
    factorSensitivityType: getFactorSensitivityType(state, props),
  }),
  required: ["account", "modelId", "positionSetId", "positionSetType"],
  data: [{
    resource: "compositeFactorSensitivity",
    as: null,
    url: ({ positionSetId, positionSetType, modelId, isActive, startDate, endDate, base, baseSignature, baseStartDate, expand, segment, factorSensitivityType }) => {
      if (isActive && startDate < baseStartDate) {
        startDate = baseStartDate
      }

      return {
        id: `factorSensitivity-${factorSensitivityType}${modelId}${positionSetId}${positionSetType}${startDate}${endDate}${isActive}${baseSignature}${JSON.stringify(segment)}${expand}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $startDate: Date!, $endDate: Date!, $base: [PositionSetInput], $factorSensitivityType: FactorSensitivityType!, $stdDev: PositiveFloat, $days: PositiveInt, $horizon: FactorSensitivityTimeHorizon!) {
          model (id: $modelId) {
            simulation (positionSet: $positionSet, from: $startDate, to: $endDate, base: $base, interval: AUTO) {
              factorSensitivity (type: $factorSensitivityType horizon: $horizon stdDev: $stdDev days: $days) {
                date
                factors {
                  id
                  name
                  category
                  sensitivity
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            type: convertPositionSetType(positionSetType),
            id: positionSetId,
            segment,
            expand,
          },
          startDate,
          endDate,
          ...getFactorSensitivityQueryParams(factorSensitivityType),
          base: isActive ? [base] : undefined,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzeCompositeFactorSensitivity,
    data: getFilteredData(state, props),
    items: getCategoryItemsSubset(state, props),
    factorSensitivity: getFactorSensitivityData(state, props),
    firstDate: getFirstFactorSensitivityDate(state, props),
    factorCategoryId: getSelectedFactorCategoryId(state, props),
    factorCategoryName: getSelectedFactorCategoryName(state, props),
    allCategoryItems: getAllCategoryItems(state, props),
    availableSelectViewFactors: getAvailableSelectViewFactors(state, props),
    focusedChartLine: getFocusedChartLine(state),
    only: getOnly(state, props),
    fileName: getFileName(state, props),
    ...getStyleAggregation(state, props),
    displayAggregationToggle: getDisplayAggregationToggle(state, props),
    options: getOptions(state, props),
    selectedOption: getSelectedOption(state, props),
    thresholdParams: getThresholdParams(state, props),
    isOpPro: getIsOpPro(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})
